import { type ICombinedState } from '../reducers';

export const ChatBotSidebar = (state: ICombinedState) => state.chatBot.userPhoneOrEmail;
